import { render, staticRenderFns } from "./BarBtn.vue?vue&type=template&id=4db70459&scoped=true"
import script from "./BarBtn.vue?vue&type=script&lang=js"
export * from "./BarBtn.vue?vue&type=script&lang=js"
import style0 from "./BarBtn.vue?vue&type=style&index=0&id=4db70459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db70459",
  null
  
)

export default component.exports